import { FC } from 'react';

type LogoutButtonProps = {
  children: React.ReactNode;
  className?: string;
  onClick: () => void;
};

const LogoutButton: FC<LogoutButtonProps> = ({
  children,
  className,
  onClick,
}) => (
  <button
    onClick={onClick}
    className={className}
    type="button"
  >
    {children}
  </button>
);

export default LogoutButton;
